<template>
  <header>
    <Head>
      <title>Citron Digital - Facturation électronique français sécurisé | Gestion clients & comptabilité</title>

      <meta name="description" content="Logiciel français de facturation électronique, gestion de clients, prospection et comptabilité. Données sécurisées et hébergées en France." />

      <meta name="keywords" content="facturation électronique, logiciel facturation France, gestion client, prospection commerciale, comptabilité, logiciel SaaS français, RGPD" />

      <!-- Open Graph -->
      <meta property="og:title" content="Logiciel de facturation électronique français sécurisé" />
      <meta property="og:description" content="Gérez vos factures, clients et comptabilité avec un logiciel français sécurisé et conforme." />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="/img/logo_nav.png" />

      <!-- SEO technique -->
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Citron Digital" />

      <!-- Données RGPD / confiance -->
      <meta name="geo.region" content="FR" />
    </Head>
    <PublicNav v-if="isPublicChrome"/>
    <ConfiguratedNav v-else/>
  </header>
  <main :class="{'main--public': isPublicPage}">
    <router-view/>
  </main>
  <PublicFooter v-if="isPublicChrome"/>
  <CustomFooter v-else logo_img="../../img/logo_nav.png" />
</template>

<script>

  import ConfiguratedNav from "@/components/configuratedNav/ConfiguratedNav.vue";
  import CustomFooter from "@/components/customFooter/CustomFooter.vue";
  import PublicNav from "@/components/public/PublicNav.vue";
  import PublicFooter from "@/components/public/PublicFooter.vue";
  import {Head} from "@vueuse/head";

  // Pages hors connexion : accès au compte, puis pages d'information (visibles aussi une fois connecté)
  const ACCESS_PAGES = ['Login', 'Register', 'ConfirmMail', 'MailAlreadyCheck', 'ResetPassword', 'Logout'];
  const INFO_PAGES = ['Legal', 'Who', 'Price', 'Assistance'];

  export default {
    components: {
      // eslint-disable-next-line vue/no-reserved-component-names
      Head,
      CustomFooter,
      ConfiguratedNav,
      PublicNav,
      PublicFooter
    },
    data: function () {
      return {
        isPhone: false,
        isTablet: false,
        isDesktop: false,
        isConnected: localStorage && localStorage.isConnected === "true",
      }
    },
    computed: {
      // Pages au décor « hors connexion » (papier réglé, feuilles, boutons citron). L'accueil ne l'a que pour une personne non connectée.
      isPublicPage() {
        const name = this.$route.name;
        if (ACCESS_PAGES.includes(name) || INFO_PAGES.includes(name)) {
          return true;
        }
        return name === 'Home' && !this.isConnected;
      },
      // Barre et pied de page hors connexion : seulement quand personne n'est connecté (sinon on garde la navigation de l'application)
      isPublicChrome() {
        return this.isPublicPage && (!this.isConnected || this.$route.name === 'Logout');
      }
    },
    methods: {
      setResolutionType() {
        const MAX_RES_PHONE = 700;
        const MAX_RES_TABLET = 1200;
        this.isPhone = window.outerWidth < MAX_RES_PHONE;
        this.isTablet = MAX_RES_PHONE <= window.outerWidth && window.outerWidth < MAX_RES_TABLET;
        this.isDesktop = MAX_RES_TABLET <= window.outerWidth;
      }

    },
    mounted() {
      this.setResolutionType();
      window.onresize = function () {
        this.setResolutionType();
      }.bind(this);
      // Même évènement que la barre de navigation : connexion ou déconnexion
      window.addEventListener('isConnectedChange', (event) => {
        this.isConnected = event.detail.isConnected;
      });
    }
  }

</script>

<style lang="stylus">
  @import '~/src/common/style/common.styl';
  @import '~/src/common/style/public.global.styl';

  // Titres de l'application connectée (modales comprises) : police système en gras, à la place de Calder-LC qui reste celle du texte.
  // Les pages hors connexion (main--public) gardent leur typographie, voir public.global.styl
  main:not(.main--public)
    h1, h2, h3, h4, h5, h6
      font-family FONT_TITLE
      font-weight 700
</style>
